module.exports = __webpack_public_path__ + "static/media/Monopoly_Logo_GB.47f02c58.png";